<template>
  <HeadlessTooltip
    :anchor-reference
    :placement="placement ?? 'bottom'"
    :offset="offset"
    :flip="flip"
    :shift="shift"
    :auto-update="autoUpdate"
    :delay-enter="delayEnter"
  >
    <div
      class="rounded-md p-2 text-2xs whitespace-pre-line"
      :class="
        variant === 'dark'
          ? 'max-w-[280px] bg-surface-800 leading-[17px] text-white'
          : 'max-w-64 border border-surface-200 bg-white leading-tight text-surface-700 shadow-md'
      "
    >
      {{ text }}
    </div>
  </HeadlessTooltip>
</template>

<script setup lang="ts">
import type { HeadlessTooltipProps } from '~/components/Headless/HeadlessTooltip.vue'

export interface AppTooltipBasicProps extends HeadlessTooltipProps {
  text: string
  /**
   * `dark` is the surface-800 explainer tooltip from the checks design
   * (`v-tooltipv2:top.dark`). Everything else keeps the white one.
   */
  variant?: 'light' | 'dark'
}

withDefaults(defineProps<AppTooltipBasicProps>(), {
  offset: 4,
  flip: true,
  shift: true,
  autoUpdate: true,
  delayEnter: 500,
  variant: 'light',
})
</script>
